"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _productOption = _interopRequireDefault(require("./product-option"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var arrSum = function arrSum(arr) {
  return arr.reduce(function (prev, curr) {
    return prev + curr;
  }, 0);
};
var getProductPricing = function getProductPricing(_ref) {
  var options = _ref.options,
    isBundle = _ref.isBundle;
  if (!options) return {};
  var prices = {};
  var minPrice = {};
  var maxPrice = {};
  var hasMultiplePrices = {};
  var pricing = options.filter(function (option) {
    return (option === null || option === void 0 ? void 0 : option.inStock) && (option === null || option === void 0 ? void 0 : option.price);
  }).map(function (option) {
    return option === null || option === void 0 ? void 0 : option.price;
  });
  pricing.forEach(function (optionPrice) {
    Object.keys(optionPrice).forEach(function (currency) {
      prices[currency] = prices[currency] || [];
      prices[currency].push(optionPrice[currency]);
    });
  });
  Object.keys(prices).forEach(function (currency) {
    minPrice[currency] = isBundle ? arrSum(prices[currency]) : Math.min.apply(Math, _toConsumableArray(prices[currency]));
    maxPrice[currency] = isBundle ? minPrice[currency] : Math.max.apply(Math, _toConsumableArray(prices[currency]));
    hasMultiplePrices[currency] = isBundle ? false : new Set(prices[currency]).size > 1;
  });
  return {
    prices: prices,
    minPrice: minPrice,
    maxPrice: maxPrice,
    hasMultiplePrices: hasMultiplePrices
  };
};
var createProduct = function createProduct(_ref2) {
  var _sys$contentType;
  var sys = _ref2.sys,
    fields = _ref2.fields;
  var options = (0, _utils.getProp)(fields, 'options') ? fields.options.map(function (option) {
    return (0, _productOption["default"])(option);
  }) : [];
  var isBundle = (0, _utils.getProp)(fields, 'isBundle');
  var hasOptionsInStock = options.some(function (opt) {
    return opt.inStock;
  });
  return _objectSpread({
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    component: (0, _utils.getProp)(fields, 'component'),
    name: (0, _utils.getProp)(fields, 'name'),
    identifier: (0, _utils.getProp)(fields, 'identifier'),
    inStock: (0, _utils.getProp)(fields, 'inStock') && hasOptionsInStock,
    isBundle: isBundle,
    options: options
  }, getProductPricing({
    options: options,
    isBundle: isBundle
  }));
};
var _default = createProduct;
exports["default"] = _default;